import {
  DefaultButton,
  Dialog,
  DialogFooter,
  ButtonsGroupChoiceField,
  SubmissionForm,
  TextInputField,
  getTheme,
  IDialogProps,
  LabeledText,
  LabeledTextGroup,
  Stack
} from "@bps/fluent-ui";
import { CopyableGuid } from "@components/CopyableText";

import { CustomerAccountUser } from "@libs/api/gateways/cam/cam-gateway.dtos";

interface Props extends Pick<IDialogProps, "onDismiss"> {
  pltUser: CustomerAccountUser | undefined;
}

export const UserModal = ({ pltUser: initialUser, onDismiss }: Props) => {
  const theme = getTheme();

  const handleSubmit = async () => {
    onDismiss?.();
  };

  const handleCancel = () => {
    onDismiss?.();
  };

  return (
    <Dialog
      dialogContentProps={{
        title: "Customer Account User",
        showCloseButton: true,
        onDismiss
      }}
      hidden={false}
    >
      <SubmissionForm<CustomerAccountUser>
        initialValues={initialUser}
        disabled
        onSubmit={handleSubmit}
        hideButtons
      >
        {() => {
          return (
            <Stack verticalFill tokens={{ childrenGap: theme.spacing.m }}>
              <Stack horizontal tokens={{ childrenGap: theme.spacing.s2 }}>
                <TextInputField name="firstName" label="First Name" />
                <TextInputField name="lastName" label="Last Name" />
              </Stack>
              <Stack horizontal tokens={{ childrenGap: theme.spacing.s2 }}>
                <TextInputField name="crmEmail" label="CRM Email" />
              </Stack>
              <Stack horizontal tokens={{ childrenGap: theme.spacing.s2 }}>
                <TextInputField name="tenantUsername" label="Tenant Username" />
              </Stack>
              <Stack>
                <ButtonsGroupChoiceField
                  label="CRM Status"
                  name="crmStatus"
                  options={[
                    {
                      key: "ACTIVE",
                      text: "Active",
                      disabled: true
                    },
                    {
                      key: "INACTIVE",
                      text: "Inactive",
                      disabled: true
                    }
                  ]}
                />
              </Stack>
              <Stack>
                <ButtonsGroupChoiceField
                  label="BpCloud Status"
                  name="status"
                  options={[
                    {
                      key: "ACTIVE",
                      text: "Active",
                      disabled: true
                    },
                    {
                      key: "INACTIVE",
                      text: "Inactive",
                      disabled: true
                    }
                  ]}
                />
              </Stack>

              <TextInputField name="crmRoles" label="CRM Roles" multiline />

              <LabeledTextGroup horizontalColumnCount={2}>
                <LabeledText wrap={false} label="CRM Contact ID">
                  <CopyableGuid value={initialUser?.crmContactId || ""} short />
                </LabeledText>
                <LabeledText wrap={false} label="Tenant ID">
                  <CopyableGuid value={initialUser?.tenantId || ""} short />
                </LabeledText>
                <LabeledText wrap={false} label="Tenant User ID">
                  <CopyableGuid value={initialUser?.tenantUserId || ""} short />
                </LabeledText>
                <LabeledText wrap={false} label="BP ID User ID">
                  <CopyableGuid value={initialUser?.bpIdUserId || ""} short />
                </LabeledText>
              </LabeledTextGroup>

              <DialogFooter>
                <DefaultButton
                  text="Close"
                  onClick={handleCancel}
                  data-test="cancel-button"
                />
              </DialogFooter>
            </Stack>
          );
        }}
      </SubmissionForm>
    </Dialog>
  );
};
